/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { VoucherCreateSchema } from '../models/VoucherCreateSchema';
import type { VoucherDetailSchema } from '../models/VoucherDetailSchema';
import type { VoucherListSchema } from '../models/VoucherListSchema';
import type { VoucherType } from '../models/VoucherType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class VouchersApi {
    /**
     * Get Vouchers For Patient
     * Get patient voucher list, <br>Required Permission: get_patient_voucher_list
     * @returns VoucherListSchema OK
     * @throws ApiError
     */
    public static vouchersGetVouchersForPatientGet({
        patientId,
        voucherType,
    }: {
        patientId: string,
        voucherType?: (VoucherType | null),
    }): CancelablePromise<Array<VoucherListSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/vouchers/{patient_id}/',
            path: {
                'patient_id': patientId,
            },
            query: {
                'voucher_type': voucherType,
            },
        });
    }
    /**
     * Create Patient Voucher
     * Create new patient voucher, <br>Required Permission: create_patient_voucher
     * @returns VoucherDetailSchema Created
     * @throws ApiError
     */
    public static vouchersCreatePatientVoucherPost({
        patientId,
        requestBody,
    }: {
        patientId: string,
        requestBody: VoucherCreateSchema,
    }): CancelablePromise<VoucherDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/vouchers/{patient_id}/',
            path: {
                'patient_id': patientId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Patient Voucher Detail
     * Get patient voucher detail, <br>Required Permission: get_patient_voucher_detail
     * @returns VoucherDetailSchema OK
     * @throws ApiError
     */
    public static vouchersGetPatientVoucherDetailGet({
        patientId,
        voucherId,
    }: {
        patientId: string,
        voucherId: string,
    }): CancelablePromise<VoucherDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/vouchers/{patient_id}/{voucher_id}/',
            path: {
                'patient_id': patientId,
                'voucher_id': voucherId,
            },
        });
    }
    /**
     * Delete Patient Voucher
     * Delete patient voucher. <br>Required Permission: delete_patient_voucher
     * @returns void
     * @throws ApiError
     */
    public static vouchersDeletePatientVoucherDelete({
        patientId,
        voucherId,
    }: {
        patientId: string,
        voucherId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/vouchers/{patient_id}/{voucher_id}/',
            path: {
                'patient_id': patientId,
                'voucher_id': voucherId,
            },
        });
    }
}
